import { mallApi } from '../request'
import { apiPath } from '../api'

export const lottery = {
  getLotteryLuck: data => mallApi.post(apiPath.getLotteryLuck, data)
}
